import { TextareaProps, Textarea } from "@chakra-ui/react";
import React from "react";
import ResizeTextarea from "react-textarea-autosize";

interface AutoResizeTextareaProps extends TextareaProps {
    disabled?: boolean;
    readOnly?: boolean;
}

export const AutoResizeTextarea = React.forwardRef<HTMLTextAreaElement, AutoResizeTextareaProps>((props, ref) => {
  return (
    <Textarea
      minH="80px"
      overflow="hidden"
      w="100%"
      resize="none"
      ref={ref}
      minRows={1}
      as={ResizeTextarea}
      {...props}
    />
  );
});